import React from "react";
import NextImage from "Components/fallback_image/next_image";
import Vars from "Consts/vars";

const Mobile = (props) => {

	const prop = props;
	return (
		<div className="container-search-article">
			<a href={prop.url}>
				<div className="card-article">
					<div className="card-article__section-image-article">
						<NextImage
							width={100}
							height={66}
							placeholder="article"
							objectFit="cover"
							style={{ borderRadius: 4 }}
							src={prop.image}
							alt={prop.label}
							fallbackSrc={Vars.BROKEN_IMAGE.rectangle}
						/>
					</div>

					<div className="card-article__section-text">
						<p className="card-article__category">{prop.category}</p>
						<p className="card-article__article-title">{prop.title}</p>
						<p className="card-article__author">
							by
							{" "}
							{prop.author}
						</p>
					</div>

				</div>
			</a>

			<style jsx>
				{`
					.card-article {
						display: flex;
						gap: 8px;
						align-items: center;
						//margin-bottom: 12px;
					}
					.card-article__section-image-article{
						width: 100px;
						height: 66.67px;
					}
					.card-article__image-article{
						width: 100%;
						height: 100%;
						border-radius: 4px;
						object-fit: cover;
					}
					.card-article__section-text{
						max-width: calc(100% - 115px);
						word-wrap: break-word;
					}
					.card-article__category{
						font-family: 'Creato Display';
						font-style: normal;
						font-weight: 400;
						font-size: 12px;
						line-height: 16px;
						color: #DB284E;
						margin-bottom: 2px;

						text-overflow: ellipsis;
						-webkit-line-clamp: 1;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						overflow: hidden;
					}
					.card-article__article-title{
						font-family: 'Butler';
						font-style: normal;
						font-weight: 700;
						font-size: 16px;
						line-height: 24px;
						text-transform: capitalize;
						color: #13161A;
						white-space: nowrap; 
						overflow: hidden;
						text-overflow: ellipsis;    
						margin-bottom: 2px;
  
					}
					.card-article__author{
						font-family: 'Creato Display';
						font-style: normal;
						font-weight: 400;
						font-size: 12px;
						line-height: 16px;
						color: #919EAB;
					}
				`}
			</style>

		</div>
	);

};

export default Mobile;
